<template>
    <div>
        <h3 class="text-center m-b-30">Sobre você</h3>

        <div class="account-content">
            <div class="row">
                <div class="col-xs-12">
                    <p class="text-muted m-b-20"><small>Nos fale um pouco sobre você. Isso nos ajudará a encontrar locais mais adequados ao seu perfil.</small></p>
                </div>
            </div>

            <div class="row m-b-10">
                <div class="col-xs-12">
                    <label class="m-b-15 control-label" style="display: block">Detalhes</label>
                    <div class="checkbox checkbox-success m-b-15">
                        <input name="student" id="student" v-model="form.student" type="checkbox" />
                        <label for="student">Estudante</label>
                    </div>
                    <transition name="fade" mode="out-in" v-if="form.student">
                        <div class="form-group m-b-15 m-l-15">
                            <textarea name="" class="form-control about_txtarea" v-model="form.about_student" id="" cols="30" rows="2" maxlength="160" placeholder="Nos conte um pouco mais sobre seus estudos. Exemplo: Estudante de Nutrição na PUC"></textarea>
                        </div>
                    </transition>
                    <div class="checkbox checkbox-success m-b-15">
                        <input name="has_job" id="has_job" v-model="form.has_job" type="checkbox" />
                        <label for="has_job">Possui um trabalho</label>
                    </div>
                    <transition name="fade" mode="out-in" v-if="form.has_job">
                        <div class="form-group m-b-15 m-l-15">
                            <textarea name="" class="form-control about_txtarea" v-model="form.about_job" id="" cols="30" rows="2" maxlength="160" placeholder="Nos conte um pouco mais sobre seu trabalho.  Exemplo: Designer na empresa X"></textarea>
                        </div>
                    </transition>
                    <div class="checkbox checkbox-success m-b-15">
                        <input name="has_no_job" id="has_no_job" v-model="form.unemployed" type="checkbox" />
                        <label for="has_no_job">Sem trabalho no momento</label>
                    </div>
                    <div class="checkbox checkbox-success m-b-15">
                        <input name="retired" id="retired" v-model="form.retired" type="checkbox" />
                        <label for="retired">Aposentado(a)</label>
                    </div>
                    <div class="checkbox checkbox-success m-b-15">
                        <input name="has_kid" id="has_kid" v-model="form.has_kid" type="checkbox" />
                        <label for="has_kid">Possui ou planeja levar alguma criança para o local</label>
                    </div>
                    <div class="checkbox checkbox-success m-b-15">
                        <input name="has_pet" id="has_pet" v-model="form.has_pet" type="checkbox" />
                        <label for="has_pet">Possui um animal de estimação</label>
                    </div>
                    <transition name="fade" mode="out-in" v-if="form.has_pet">
                        <div class="checkbox checkbox-success m-b-15 m-l-15">
                            <input name="carrying_pets" id="carrying_pets" v-model="form.carrying_pets" type="checkbox" />
                            <label for="carrying_pets">Desejo levar meu animal de estimação</label>
                        </div>
                    </transition>
                    <transition name="fade" mode="out-in" v-if="!form.has_pet">
                        <div class="checkbox checkbox-success m-b-15">
                            <input name="accepting_pets" id="accepting_pets" v-model="form.accepting_pets" type="checkbox" />
                            <label for="accepting_pets">Aceito viver com animais de estimação</label>
                        </div>
                    </transition>
                    <div class="checkbox checkbox-success m-b-15">
                        <input name="smoker" id="smoker" v-model="form.smoker" type="checkbox" />
                        <label for="smoker">É fumante</label>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <div class="form-group" v-bind:class="{'has-error': errors.has('about_me')}">
                        <label for="about_me" class="control-label">Nos conte um pouco mais sobre você</label>
                        <textarea name="about_me" data-vv-as="sobre" v-validate="'required'" class="form-control" v-model="form.about_me" cols="30" rows="6" placeholder="Use este campo para falar um pouco sobre você. Suas preferências, alguns gostos pessoais, enfim, tente nos dizer um pouco sobre a sua pessoa. Nunca inclua informações pessoais como número de telefone, email ou perfil de redes sociais."></textarea>
                        <span class="help-block text-left" v-show="errors.has('about_me')">
                            <strong>{{ errors.first('about_me') }}</strong>
                        </span>
                    </div>
                </div>
            </div>

            <div class="row m-t-20">
                <div class="col-xs-12">
                    <div class="form-group account-btn text-right">
                        <button @click="goBack" class="btn btn-clear btn-white pull-left">Voltar</button>
                        <button @click="submit()" class="btn btn-bordered btn-success waves-effect waves-light w-lg ladda-button btn-submit" type="submit">Continuar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['obj'],
    data: function () {
        return {
            form: this.obj
        }
    },
    watch: {
        'form.has_pet': function (newVal) {
            if (!newVal) {
                this.form.carrying_pets = false;
            }
        }
    },
    methods: {
        goBack: function () {
            this.$emit('goback');
        },
        submit: function () {
            this.$validator.validateAll().then((res) => {
                if (res === false) {
                    return false;
                }

                this.$emit('submit', this.form);
                window.scrollTo(0,0);
            });
        }
    }
}
</script>

<style lang="scss">
    .about_txtarea {
        min-height: 70px !important;
        height: 70px !important;
    }
</style>
